import React from "react"
import '../css/Navbar.css'

const Navbar = ({selectNav, selectedNav, isDarkMode}) =>{

    const selected = (isDarkMode) => {
        return isDarkMode ? 'selected' : 'selected_light'
    }

    return (
        <div>
            <div className="navbar">
                <div className="navItem" onClick={() => selectNav('about')}>
                    <div className={`${selectedNav === 'about' ? selected(isDarkMode) : ''}`}>About</div>
                    <div className={`nav_selector ${selectedNav === 'about' ? 'selected' : 'hidden'}`}></div>
                </div>

                <div className="navItem" onClick={() => selectNav('projects')} >
                    <div className={`${selectedNav === 'projects' ? selected(isDarkMode) : ''}`}>Projects</div>
                    <div className={`nav_selector ${selectedNav === 'projects' ? 'selected' : 'hidden'}`}></div>
                </div>

                <div className="navItem" onClick={() => selectNav('experience')}>
                    <div className={`${selectedNav === 'experience' ? selected(isDarkMode) : ''}`}>Experience</div>
                    <div className={`nav_selector ${selectedNav === 'experience' ? 'selected' : 'hidden'}`}></div>
                </div>
                
                <div className="navItem" onClick={() => selectNav('contact')}>
                    <div className={`${selectedNav === 'contact' ? selected(isDarkMode) : ''}`}>Contact</div>
                    <div className={`nav_selector ${selectedNav === 'contact' ? 'selected' : 'hidden'}`}></div>
                </div>
            </div>
        
            <hr/>
        </div>
    )
}

export default Navbar